module.exports = __webpack_public_path__ + "img/about_mental.e6452c9b.jpg";